export default __webpack_public_path__ + "static/media/industry.7d30219a.png";